import { render } from "./FaqLayout.vue?vue&type=template&id=64981dc2&scoped=true"
import script from "./FaqLayout.vue?vue&type=script&lang=js"
export * from "./FaqLayout.vue?vue&type=script&lang=js"

import "./FaqLayout.vue?vue&type=style&index=0&id=64981dc2&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64981dc2"]])

export default __exports__